import { breakpoints } from '../helpers/breakpoints';
import { BRANDS, determineBrandFromURL } from '../helpers/brand';

export const featuredImageSearchComponent = () => {
  let tickingResize = false;
  const brand = determineBrandFromURL();

  const headerFeatureImg = document.querySelector<HTMLElement>('[js-header-feature-img]');
  const search = document.querySelector<HTMLElement>('[js-search-component]');
  const snackbar = document.querySelector<HTMLElement>('[js-snackbar]');
  const snackbarHide = snackbar?.querySelector<HTMLElement>('[js-hide-snackbar]');

  const resizeHandler = () => {
    if (brand === BRANDS.WILDE) {
      const resizeComponent = () => {
        if (headerFeatureImg && search) {
          if (window.innerWidth < breakpoints.screen1024) {
            const snackbarHeight = snackbar?.getBoundingClientRect().height ?? 0;
            headerFeatureImg.style.minHeight = `unset`;
            headerFeatureImg.style.maxHeight = `600px`;
            headerFeatureImg.style.height = `calc(100dvh - ${snackbarHeight}px)`;
          } else {
            headerFeatureImg.removeAttribute('style');
          }
        }
      };
      snackbarHide?.addEventListener('click', () => {
        if (headerFeatureImg && search && window.innerWidth < breakpoints.screen1024) {
          setTimeout(() => {
            resizeComponent();
          }, 250);
        }
      });

      resizeComponent();
    }
  };

  ['load', 'resize'].forEach((event) =>
    window.addEventListener(event, () => {
      if (!tickingResize) {
        window.requestAnimationFrame(() => {
          resizeHandler();
          tickingResize = false;
        });
      }
      tickingResize = true;
    })
  );
};
